import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'
import Iframe from 'react-iframe'
import {
  useNavigate
} from "react-router-dom";
export default function LeaveForm() {

  const FORM_URL = "https://form.jotform.com/231158623817054";

  const navigate = useNavigate()

  const goBack = () => {
    navigate('/')
  }
  return (
    <>
    <Navbar/>
    <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="jotform-wrapper">
      <div className="go-back-button device-page-button" onClick={goBack}>back</div>
        <Iframe url={FORM_URL} height="1600px" width="100%" frameBorder="0"/>
      </div>
    
    <Footer/>
    </div>
  </>
  )
}
